module.exports = kolibriGlobal.coreVue.components.UiAlert;